/* Header search: toggle bar + live suggestions via /search/suggest.json */
(function () {
  var bar = document.querySelector('[data-search-bar]');
  if (!bar) return;
  var input = bar.querySelector('[data-search-input]');
  var results = bar.querySelector('[data-search-results]');
  var toggles = document.querySelectorAll('[data-search-toggle]');
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var searchUrl = (window.theme && window.theme.routes && window.theme.routes.search) || '/search';
  var timer = null, lastQ = '', ctrl = null;

  function money(cents) { return window.theme && window.theme.formatMoney ? window.theme.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function open() {
    bar.hidden = false;
    document.body.classList.add('search-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    var nav = document.querySelector('[data-nav]');
    if (nav) nav.classList.remove('is-open');
    setTimeout(function () { input.focus(); }, 20);
  }
  function close() {
    bar.hidden = true;
    document.body.classList.remove('search-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    results.hidden = true; results.innerHTML = '';
  }

  function render(json, q) {
    var products = (json.resources && json.resources.results && json.resources.results.products) || [];
    if (!products.length) { results.innerHTML = '<div class="header__suggest-empty">NO MATCHES FOR “' + esc(q) + '” — <a href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">SEARCH ANYWAY →</a></div>'; results.hidden = false; return; }
    var html = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '&width=120" alt="" loading="lazy">' : '';
      var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
      return '<a class="header__suggest-item" href="' + esc(p.url) + '"><span class="header__suggest-img">' + img + '</span><span class="header__suggest-title">' + esc(p.title) + '</span><span class="header__suggest-price">' + price + '</span></a>';
    }).join('');
    html += '<a class="header__suggest-all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">ALL RESULTS FOR “' + esc(q) + '” →</a>';
    results.innerHTML = html; results.hidden = false;
  }

  function suggest() {
    var q = input.value.trim();
    if (q.length < 2) { results.hidden = true; results.innerHTML = ''; lastQ = ''; return; }
    if (q === lastQ) return;
    lastQ = q;
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { signal: ctrl && ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (json) { if (input.value.trim() === q) render(json, q); })
      .catch(function () {});
  }

  toggles.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      if (bar.hidden) open(); else close();
    });
  });
  bar.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
  var navToggle = document.querySelector('[data-nav-toggle]');
  if (navToggle) navToggle.addEventListener('click', function () { if (!bar.hidden) close(); });
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 180); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !/input|textarea|select/i.test((e.target && e.target.tagName) || '') && bar.hidden) { e.preventDefault(); open(); }
  });
  document.addEventListener('click', function (e) {
    if (bar.hidden) return;
    if (e.target.closest('[data-search-bar]') || e.target.closest('[data-search-toggle]')) return;
    close();
  });
})();
